// Copyright (c) 2019 Deere & Company

import Notification from './notification';
import t from 'tcomb';

const Notifications = Notification.extend({
    createdAt: t.maybe(t.Number),
    createdBy: t.Any,
    id: t.Number,
    updatedAt: t.maybe(t.Number),
    updatedBy: t.Any,
}, {
    name: 'Notifications',
    strict: false,
});

export const getNotificationsDefaultState = () => new Notifications({
    createdAt: null,
    createdBy: '',
    id: 0,
    language: '',
    shortText: '',
    title: '',
    updatedAt: null,
    updatedBy: '',
    url: '',
});

export default Notifications;
